import React, { useState } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import AppHeader from "./Header";
import useBreakpoint from "../../hooks/useBreakpoint";

export default function AppLayout() {
  const { isMobile } = useBreakpoint();
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Layout className="min-h-screen">
      {!isMobile ? (
        <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
      ) : (
        <Sidebar
          asDrawer
          drawerOpen={drawerOpen}
          onDrawerClose={() => setDrawerOpen(false)}
        />
      )}
      <Layout>
        <AppHeader
          showMenuButton={isMobile}
          onMenuClick={() => setDrawerOpen(true)}
        />
        <Layout.Content className="page-content">
          <Outlet />
        </Layout.Content>
      </Layout>
    </Layout>
  );
}
